<template>
  <div class="footer row">
    <div class="col-2 col-sm-12">
      <img src="/images/logo-white.png" class="footer__logo" />      
    </div>
    <div class="col-1 desktop"></div>
    <div class="col-9 col-sm-12">
      <div class="footer__infos row">
        <div class="col--third-marg">
          <router-link to="/">Accueil</router-link><br>
          <router-link to="/agenda">Agenda</router-link><br>
          <router-link to="/identite">Identité</router-link><br>
          <router-link to="/la-plage">La Plage</router-link><br>
          <a href="" v-on:click.prevent="openPopin" class="link-popin link-popin--mecene">Mécènes</a><br>
          <a href="https://billetterie.gtg.ch/list/events" class="round-button round-button--menu round-button--white" target="_blank">Billetterie</a>
        </div>
        <div class="col--third-marg">
          Grand Théâtre de Genève<br>
          Case Postale 5126<br>
          CH–1211 Genève 11
        </div>
        <div class="col--third-marg">
          Administration +41 22 322 50 00<br>
          Billetterie +41 22 322 50 50
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.footer{
  background-color: black;
  color: white;
  padding: 20rem $col-size;
  font-size: 1.4rem;
  line-height: 2.8rem;
  font-weight: bold;
  text-transform: uppercase;
  @media #{$bp-sm}{
    text-align: center;
    padding: 8rem 0 14rem;
  }
  &__logo{
    width: 12rem;
    @media #{$bp-sm}{
      margin: 0 auto;
    }
  }
  &__infos{
    margin-top: 6rem;
    @media #{$bp-sm}{
      .col--mid:first-child{
        margin-bottom: 4rem;
      }
    }
    a{
      color: white;
      text-decoration: none;
      &:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    openPopin(){
      this.$store.commit('openPopin', 'mecene')
    }
  },
  mounted() {
  },
};
</script>
